<template>
    <div>
      <div class="header-return">
        <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
      </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >

            <el-form-item>
              <el-button type="success" @click="addBatchInfo()">新增</el-button>
            </el-form-item>
        </el-form>

      <el-table :data="batchFreeList" stripe border center :size="GCONFIG.styleTableSize"  v-loading="loading1">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="freeName" label="赠品"></el-table-column>
        <el-table-column prop="freeTypeName" label="赠送类型"></el-table-column>
        <el-table-column prop="freeMethodName" label="赠送方式"></el-table-column>
        <el-table-column prop="freeProductTypeName" label="赠品类型"></el-table-column>
        <el-table-column prop="freeQuantity" label="赠品数量"></el-table-column>
        <el-table-column prop="statusName" label="状态"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="opeater" label="创建人"></el-table-column>

        <el-table-column label="操作" fixed="right" width="160">
          <template slot-scope="scope">

            <el-button type="success" size="mini"
                       @click="modifyBatchFree(scope.row)">修改</el-button>

            <el-button type="warning" size="mini"
                       @click="deleteBatchFree(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>


        <!-- 新增/修改 -->
        <el-dialog title="新增赠品" :visible.sync="dialogFormVisible" center  center top="5vh">
            <el-form :model="form" label-width="150px" size="small ">

                <el-form-item label="赠品" :required="true">
                  <el-select  v-model="form.freeId" clearable>
                    <el-option v-for="item in Frees"
                               :key="item.freeId"
                               :label="item.freeName"
                               :value="item.freeId">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="赠送类型" :required="true">
                  <el-select v-model="form.freeType" placeholder="赠送类型" >
                    <el-option label="必赠" :value=1></el-option>
                    <el-option label="选赠" :value=2></el-option>
                  </el-select>
                  <p>必赠：每个用户都会有的赠品；选赠：是需要客服未用户设置赠品，然后客户才能选择赠品</p>
                </el-form-item>
              <el-form-item label="赠品商品类型" :required="true">
                <el-select v-model="form.freeProductType" placeholder="赠品商品类型" >
                  <el-option label="冷链" :value=1></el-option>
                  <el-option label="常温" :value=2></el-option>
                  <el-option label="中性" :value=3></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="赠送权限" :required="true">
                <el-select v-model="form.cright" placeholder="赠送权限" >
                  <el-option label="客服" :value=1></el-option>
                  <el-option label="客户" :value=2></el-option>
                  <el-option label="两者都可" :value=3></el-option>
                </el-select>
                <p>是指谁可以选择赠品，一般情况下设置为【两者都可】</p>
              </el-form-item>

                <el-form-item label="赠送方式" :required="true">
                    <el-select v-model="form.freeMethod" placeholder="赠送方式" >
<!--                        <el-option label="随卡单" :value=1></el-option>-->
                        <el-option label="赠品池" :value=2></el-option>
<!--                        <el-option label="单独发" value=3></el-option>-->

                    </el-select>
                </el-form-item>

                <el-form-item  label="赠品数量" :required="true">
                    <el-input v-model="form.freeQuantity" placeholder="赠品数量" clearable></el-input>
<!--                    <span style="color: red">请填写数字</span>-->
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveBatchFree()">确 定</el-button>
            </div>
        </el-dialog>



    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {getCardFreeList,saveCardFree,getSinglePrepayCardFree,deletePrepayCardFree,getOptionFreeList} from '@/api/api';
    export default {
        data() {
            return {
                showDialog: false,
                dialogFormVisible: false,
                form: {
                  id:null,
                  batchId:this.$route.params.batchId,
                  source:this.$route.params.source,
                  freeId:'',
                  freeType:1,
                  freeProductType:1,
                  freeQuantity:0,
                  freeMethod:2,
                  status:1,
                  createTime:null,
                  opeater:null,
                  cright:1,
                },
                formInline: {
                  cardBatchId:this.$route.params.batchId,
                  source:this.$route.params.source,
                },
              batchFreeList:[],
              Frees:[],
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
          getOptionFreeList().then((res) => {
            if (res.data.status == 200) {
              this.Frees = res.data.value;
            } else {
              this.$message({
                showClose: true,
                message: res.data.message,
                type: 'error'
              });
            }
          });
          this.queryBatchInfo();
        },
        components:{

        },
        methods: {

            queryBatchInfo(){
              getCardFreeList(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.batchFreeList = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },

            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.queryBatchInfo();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.queryBatchInfo();
            },
            handleSizeChange1(val) {
                this.formInline1.pageSize = val;
                this.queryCardInfo();
            },
            handleCurrentChange1(val) {
                this.formInline1.currentPage = val;
                this.queryCardInfo();
            },

            //新增事件
            addBatchInfo() {
                this.form = {
                  id:null,
                  batchId:this.$route.params.batchId,
                  source:this.$route.params.source,
                  freeId:'',
                  freeType:1,
                  freeProductType:1,
                  freeQuantity:0,
                  freeMethod:2,
                  status:1,
                  createTime:null,
                  opeater:null,
                  cright:1,
                };
                this.dialogFormVisible = true;
            },
            //确定事件
          saveBatchFree() {

              if(this.form.batchId ==''){
                  this.$message({
                      showClose: true,
                      message: '没有选择卡批次或会员等级',
                      type: 'error'
                  });
                  return false;
              }
              if(this.form.source ==''){
                this.$message({
                  showClose: true,
                  message: '没有对应的来源',
                  type: 'error'
                });
                return false;
              }
              if(this.form.freeId==null||this.form.freeId==''){
                this.$message({
                  message:"请选择赠品",
                  type:'error'
                });
                return;
              }
              if(this.form.freeType==null||this.form.freeType==''){
                this.$message({
                  message:"请选择赠品类型",
                  type:'error'
                });
                return;
              }

                if(this.form.freeProductType==null||this.form.freeProductType==''){
                  this.$message({
                    message:"请选择赠品商品类型",
                    type:'error'
                  });
                  return;
                }
              if(this.form.freeMethod==null||this.form.freeMethod==''){
                this.$message({
                  message:"请选择赠送方式",
                  type:'error'
                });
                return;
              }
              if(this.form.freeQuantity==null||this.form.freeQuantity==0){
                this.$message({
                  message:"请填写赠送数量",
                  type:'error'
                });
                return;
              }

            saveCardFree(this.form).then((res) => {
                    if(res.data.status != 200){  //不能绑定
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                        this.added = 0;
                    } else {
                        this.queryBatchInfo();
                        this.dialogFormVisible = false;
                    }
                });
            },
          modifyBatchFree(row){
                this.form = {
                  id:row.id,
                  batchId:row.batchId,
                  source:row.source,
                  freeId:row.freeId,
                  freeType:parseInt(row.freeType),
                  freeProductType:row.freeProductType,
                  freeQuantity:row.freeQuantity,
                  freeMethod:row.freeMethod,
                  status:row.status,
                  createTime:row.createTime,
                  opeater:row.opeater,
                  cright:row.cright,
                };
                this.dialogFormVisible = true;
            },

            //删除事件
          deleteBatchFree(row){
                this.$confirm('删除此批次, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                  deletePrepayCardFree({cardFreeId:row}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.queryBatchInfo();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
          returnHistory(){
            window.history.back()
          },

        }
    }
</script>
<style scoped>
    .order-main-num{
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/views/prepay/CardBatchFree.vue